import type { NoDataResponse } from "@core/types/api";
import type { Subscription, BillingKeyRequest } from "@core/types/subscription";

import mainAxios from "./mainAxios";

export const getSubscription = (): Promise<Subscription | null> => {
  return mainAxios.get("/api/v1/subscription").then((res) => res.data);
};

export const createSubscription = (
  request: BillingKeyRequest
): Promise<Subscription> => {
  return mainAxios
    .post("/api/v1/subscription/billing-key", request)
    .then((res) => res.data);
};

export const cancelSubscription = (): Promise<NoDataResponse> => {
  return mainAxios.delete("/api/v1/subscription").then((res) => res.data);
};
